import React, { useState, useEffect } from "react";
import placeholder from "../../img/img_placeholder.svg";
import logo360 from "../../img/360.png";
//@ts-ignore
import InnerImageZoom from "react-inner-image-zoom";
import DDeal from "../../img/DDealW.svg";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import {ArrowLeftOutlined, CloseOutlined, StarOutlined} from "@ant-design/icons";
import {history} from "../../index";
import { Button as AntButton, Modal} from "antd";

const AIIcon = (props: any) => (
  <svg
    width="3em"
    height="3em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 18H6C4.89543 18 4 17.1046 4 16V6C4 4.89543 4.89543 4 6 4H10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18 10V16C18 17.1046 17.1046 18 16 18H14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 14L8.5 10L10 14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10V14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16 3L16.5 4.5L18 5L16.5 5.5L16 7L15.5 5.5L14 5L15.5 4.5L16 3Z"
      fill="currentColor"
    />
    <path
      d="M21 7L21.3 7.9L22.2 8.2L21.3 8.5L21 9.4L20.7 8.5L19.8 8.2L20.7 7.9L21 7Z"
      fill="currentColor"
    />
    <path
      d="M20 3L20.2 3.6L20.8 3.8L20.2 4L20 4.6L19.8 4L19.2 3.8L19.8 3.6L20 3Z"
      fill="currentColor"
    />
  </svg>
);

const ProductImage = ({ oneProduct, width, setVisible, visible }: any) => {
  const [link, setLink] = useState("");
  const [url, setUrl] = useState<any>(null);
    const [isTryOnModalOpen, setIsTryOnModalOpen] = useState(false);
    const [tryOnUrl, setTryOnUrl] = useState("");

  useEffect(() => {
    if (oneProduct) {
      if (oneProduct.link_360) {
        setLink(oneProduct.link_360);
        setUrl(new URL(oneProduct.link_360));
      }
    }
  }, [visible, oneProduct]);
  if (url && url.hostname === "localhost")
    return (
      <a target="_blank" href={link}>
        {link}
      </a>
    );
  if (oneProduct && oneProduct?.images?.length) {
    return (
        <>
            {/* {!visible && oneProduct.link_360 && (
          <button className="btn-360" onClick={() => setVisible(true)}>
            <img src={logo360} alt="360 degree" width="60" />
          </button>
        )} */}
            <div
                style={{
                    display: visible ? "inline-block" : "none",
                    position: "relative",
                    height: "100%",
                    minHeight: width <= 1024 ? "calc(100vh - 227px)" : "auto",
                    width: "100%",
                }}
            >
                <button className="btn-360-close" onClick={() => setVisible(false)}>
                    <CloseOutlined
                        style={{
                            verticalAlign: -1,
                            color: "#7c7c7c",
                            fontSize: "1.2rem",
                        }}
                    />
                </button>
                <iframe
                    src={link}
                    style={{
                        width: "100%",
                        height: width <= 1024 ? "calc(100vh - 227px)" : "100%",
                        border: "none",
                    }}
                />
            </div>
            <div className={
                "go_back"
            }

                 onClick={(e: any) => {
                     e.preventDefault();
                     history.back();
                 }}
                 style={{fontSize: "1rem", position: "absolute", zIndex: 99, top: "10px", margin: "25px"}}
            >

                <ArrowLeftOutlined

                ></ArrowLeftOutlined>{" "}

            </div>
            {!visible &&
                oneProduct.images.map((el: any, i: number) => (
                    <div
                        className="product_images"
                        key={i}
                        style={{position: "relative"}}
                    >


                        {oneProduct.link_360 && (
                            <>
                            <button
                                className="btn-360"
                                style={{
                                    position: width <= 1024 ? "absolute" : "fixed",
                                    left: "10px",
                                    bottom: width <= 1024 ? "10px" : "10px",
                                    /* top: width <= 1024 ? "10px" : "unset",*/
                                }}
                                onClick={() => setVisible(true)}
                            >
                                <img src={logo360} alt="360 degree" width="60"/>
                            </button>
                           

                             <AntButton
/*                                 className="btn-ai-preview"
 */                                style={{
                                    position: width <= 1024 ? "absolute" : "fixed",
                                    left: "10px",
                                    bottom: width <= 1024 ? "60px" : "80px",
                                    display: "none",
                                }}                
                                icon={<AIIcon />}
                                onClick={() => {
                  const frontImg = oneProduct?.images?.[0]?.path || oneProduct?.images?.[0] || "";
                  const garmentUrl = process.env.REACT_APP_STORAGE_URL + frontImg;
                  setTryOnUrl(`https://tryonidwebshop.pythonanywhere.com/?garment_url=${garmentUrl}`);
                  setIsTryOnModalOpen(true);
                }}
              >
                 Preview
              </AntButton>


              <Modal
            title="AI Preview"
            visible={isTryOnModalOpen}
            onCancel={() => setIsTryOnModalOpen(false)}
            footer={null}
            width="95%"
            style={{ top: 20 }}
            bodyStyle={{ height: '85vh', padding: 0 }}
            destroyOnClose
          >
            <iframe 
              src={tryOnUrl} 
              width="100%" 
              height="100%" 
              style={{ border: 'none', borderRadius: '8px',
                         opacity: isTryOnModalOpen ? 1 : 0,
                        visibility: isTryOnModalOpen ? 'visible' : 'hidden',
                        transform: isTryOnModalOpen ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
                        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        pointerEvents: isTryOnModalOpen ? 'all' : 'none',

               }}
              title="AI Preview"
            />
          </Modal>
                            </>
                        )}
                        {oneProduct.is_denim_deal === 1 && (
                            <div className="denim_deal_ribbon_container">
                                <div className="denim_deal_ribbon">
                                    <img src={DDeal} alt="" width={80}  style={{paddingTop:'6px'}}/>
                                </div>
                            </div>
                        )}
                        <InnerImageZoom
                            src={process.env.REACT_APP_STORAGE_URL + el.path}
                            zoomSrc={process.env.REACT_APP_STORAGE_URL + el.path}
                            fullscreenOnMobile={true}
                            zoomScale={width <= 640 ? 1.3 : width >= 2560 ? 2.2 : 1.45}
                            className="lazy-load-image-background zoomed_img"
                            afterZoomIn={() => {
                                document
                                    .querySelectorAll(".lazy-load-image-background")
                                    [i]?.classList.remove("lazy-load-image-background");
                                if (width <= 640) {
                                    let x: any = document.querySelector(".iiz__zoom-portal");
                                    if (x) {
                                        x.style.background = "rgba(0,0,0,.5)";
                                        x.style.backdropFilter = "blur(5px)";
                                    }
                                }
                            }}
                            afterZoomOut={() =>
                                document
                                    .querySelectorAll(".zoomed_img")
                                    [i]?.classList.add("lazy-load-image-background")
                            }
                        />
                    </div>
                ))}
        </>
    );
  } else {
      return (
          <img
              src={placeholder}
              className="product_img"
              style={{width: "100%", height: "100%"}}
          />
      );
  }
};

export default ProductImage;
